const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'dashboard',
        title: 'Pregled',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard'
    },
    /*
    {
        name: 'settings',
        title: 'Nastavitve',
        icon: 'mdi-cogs',
        path: '/nastavitve',
        group: 'settings'
    },
    */
    {
        name: 'users_list',
        title: 'Seznam uporabnikov',
        icon: 'mdi-account-group',
        path: '/seznam-uporabnikov',
        group: 'users_list'
    },
    {
        name: 'add_user',
        title: 'Dodaj uporabnika',
        icon: 'mdi-account-plus',
        path: '/dodaj-uporabnika',
        group: 'add_user',
    },
    /*{
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: '/zasedenost-parkirisca',
        group: 'parking_occupancy',
    },*/
    
    
    {
        title: 'Zapornice',
        icon: 'mdi-remote',
        group: 'zapornice', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['ie-parking-barriers'],
        items: [
            {
                name: 'parking_barriers_management',
                title: 'Upravljanje zapornic',
                icon: 'mdi-android-messages',
                path: '/zapornice/upravljanje',
                permissions: []
            },
            {
                name: 'parking_barriers_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/zapornice/arhiv',
                permissions: [],
            }
        ]
    },

    {
        title: 'Križne zapore',
        icon: 'mdi-turnstile',
        group: 'krizne-zapore', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: [],
        items: [
            {
                name: 'turnstiles_management',
                title: 'Upravljanje križnih zapor',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/upravljanje',
                permissions: []
            },
            {
                name: 'turnstile_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/casovnica',
                permissions: [],
            },
            {
                name: 'turnstiles_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/krizne-zapore/arhiv',
                permissions: [],
            }
        ]
    },

    /*{
        name: 'validator',
        title: 'Validator',
        icon: 'mdi-barcode-scan',
        path: '/validacije',
        group: 'validator',
    }*/

    {
        name: 'exports',
        title: 'Izvoz podatkov',
        icon: 'mdi-application-export',
        path: 'izvoz-podatkov',
        group: 'exports'
    },
    
]

export { Menu }